import React, { useEffect } from 'react';
import { ThemeProvider } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { theme } from '../styles/theme/theme';
import {
  AuthPageContainer,
  AuthFormCard,
  AuthPageTitle,
  AuthSubtitle,
  AuthGradientButton,
} from '../styles/components';

const SignUpConfirm: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const redirectUrl = params.get('url');
    
    if (redirectUrl) {
      const timer = setTimeout(() => {
        window.location.href = decodeURIComponent(redirectUrl);
      }, 2000);
      
      return () => clearTimeout(timer);
    }
  }, [location.search]);

  return (
    <ThemeProvider theme={theme}>
      <AuthPageContainer>
        <AuthFormCard elevation={6}>
          <AuthPageTitle variant="h5">
            Sign Up Successful
          </AuthPageTitle>
          
          <AuthSubtitle variant="body2">
            You've registered successfully.
            {location.search ? (
              "Please wait while redirecting to your account..."
            ) : (
              "Please check your email for further instructions."
            )}
          </AuthSubtitle>

          {!location.search && (
            <AuthGradientButton
              fullWidth
              variant="contained"
              onClick={() => navigate('/sign-in')}
            >
              Go to Sign In
            </AuthGradientButton>
          )}
        </AuthFormCard>
      </AuthPageContainer>
    </ThemeProvider>
  );
};

export default SignUpConfirm; 